import React, {useState} from 'react'
import {useEffect} from "react";
import classNames from "classnames";

const Counter = ({dueDate}) => {

    const [animate, setAnimate] = useState(false)

    const [isTimerEnd, setIsTimerEnd] = useState(false)
    let now
    let diff

    const timer = (finaleDate) => {
        now = new Date().getTime();
        diff = finaleDate - now;

        if (diff < 0) {
            setIsTimerEnd(true)
            return
        }

        let days = Math.floor(diff / (1000 * 60 * 60 * 24));
        let hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        let minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
        let seconds = Math.floor(diff % (1000 * 60) / 1000);

        // eslint-disable-next-line no-unused-expressions
        days <= 9 && days > 0 ? days = `0${days}` : days === 0 ? days = `00` : days;
        // eslint-disable-next-line no-unused-expressions
        hours <= 9 ? hours = `0${hours}` : hours;
        // eslint-disable-next-line no-unused-expressions
        minutes <= 9 ? minutes = `0${minutes}` : minutes;
        // eslint-disable-next-line no-unused-expressions
        seconds <= 9 ? seconds = `0${seconds}` : seconds;

        if (document.querySelector('.count_days_bonus')) {
            document.querySelector('.count_days_bonus').textContent = days;
            document.querySelector('.count_hours_bonus').textContent = hours;
            document.querySelector('.count_minutes_bonus').textContent = minutes;
            document.querySelector('.count_seconds_bonus').textContent = seconds;
        }
    }

    useEffect(() => {
        if (dueDate) {

            let finalDate = dueDate
            // eslint-disable-next-line react-hooks/exhaustive-deps
            now = new Date().getTime();

            let diff = finalDate - now;
            timer(finalDate);
            if (diff > 0) {
                setAnimate(true)
                setInterval(() => timer(finalDate), 1000);
            }
        }
    }, [dueDate])

    return (
        <div className='countdown_wrapper'>
            <div className={
                classNames({
                    "count_item_wrapper": true,
                    "anim": animate
                })
            }>
                <div className='count_item'>
                    <span className='count count_days count_days_bonus'>00</span>
                    <span className='count_name'>{'D'}</span>
                </div>
            </div>
            <div className={
                classNames({
                    "count_item_wrapper": true,
                    "anim": animate
                })
            }>
                <div className='count_item'>
                    <span className='count count_hours count_hours_bonus'>00</span>
                    <span className='count_name'>{'H'}</span>
                </div>
            </div>
            <div className={
                classNames({
                    "count_item_wrapper": true,
                    "anim": animate
                })
            }>
                <div className='count_item'>
                    <span className='count count_minutes count_minutes_bonus'>00</span>
                    <span className='count_name'>{'M'}</span>
                </div>
            </div>
            <div className={
                classNames({
                    "count_item_wrapper": true,
                    "anim": animate
                })
            }>
                <div className='count_item'>
                    <span className='count count_seconds count_seconds_bonus'>00</span>
                    <span className='count_name'>{'S'}</span>
                </div>
            </div>
        </div>
    )
}

export default Counter